/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './InsuranceInformation.module.scss'
import { effectiveDateAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const EffectiveDate = ({
  t,
  validateEffectiveDate,
  effectiveDateError,
  effectiveDateValid,
  effectiveDateDayEl,
  effectiveDateMonthEl,
  effectiveDateYearEl,
  setIsError,
}) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const { effectiveDate } = useSelector((state) => state.app)

  const handleEffectiveDateDay = (e) => {
    try {
      const regex = RegExp(/^\d+$/)
      if (regex.test(effectiveDateDayEl.current.value)) {
        let value = effectiveDateDayEl.current.value
        if (value !== '' && parseInt(value) > 0 && parseInt(value) < 10) {
          value = '0' + value.toString()
        } else {
          value = value.substr(1)
        }
        dispatch(effectiveDateAction(`${effectiveDateYearEl.current.value}-${effectiveDateMonthEl.current.value}-${value}`))
        // validateEffectiveDate()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const formatMonth = (monthNumber) => {
    return monthNumber < 10 ? `0${monthNumber}` : `${monthNumber}`
  }

  const handleEffectiveDateMonth = (e) => {
    try {
      dispatch(
        effectiveDateAction(
          `${effectiveDateYearEl.current.value}-${effectiveDateMonthEl.current.value}-${effectiveDateDayEl.current.value}`
        )
      )
      // validateEffectiveDate()
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const handleEffectiveDateYear = (e) => {
    try {
      const regex = RegExp(/^$|^\d+$/)
      if (regex.test(effectiveDateYearEl.current.value)) {
        dispatch(
          effectiveDateAction(
            `${effectiveDateYearEl.current.value}-${effectiveDateMonthEl.current.value}-${effectiveDateDayEl.current.value}`
          )
        )
        //validateEffectiveDate()
      }
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurEffectiveDate = () => {
    SetIsFocussed(false)
    validateEffectiveDate()
  }

  const months = [
    { name: 'January', value: 1 },
    { name: 'February', value: 2 },
    { name: 'March', value: 3 },
    { name: 'April', value: 4 },
    { name: 'May', value: 5 },
    { name: 'June', value: 6 },
    { name: 'July', value: 7 },
    { name: 'August', value: 8 },
    { name: 'September', value: 9 },
    { name: 'October', value: 10 },
    { name: 'November', value: 11 },
    { name: 'December', value: 12 },
  ]

  return (
    <div className={styles['fields_margin']}>
      <div
        className={
          effectiveDateValid === true
            ? effectiveDate === '' || effectiveDate === '--'
              ? ''
              : 'form-group has-success'
            : effectiveDateValid === false
            ? 'form-group ns-form-group-message-error'
            : ''
        }
      >
        <label className="control-label" htmlFor="text">
          <b>{t('insurance_information.effective_date')}</b>
        </label>
        <div className="help-field ns-hint" style={{ marginTop: '3px' }}>
          {t('insurance_information.effective_date_example')}
        </div>
        {effectiveDateValid === false && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(effectiveDateError)}</div>
          </div>
        )}

        <div className={[styles['date-align']]}>
          <div className={styles['day_field']}>
            <label className="control-label" htmlFor="EffectiveDate" style={{ marginBottom: '0px' }}>
              <b>{t('insurance_information.dd')}</b>
            </label>
          </div>
          <div className={styles['month_field']}>
            <label className="control-label" htmlFor="EffectiveMonth" style={{ marginBottom: '0px' }}>
              <b>{t('insurance_information.month')}</b>
            </label>
          </div>
          <div className={styles['year_field']}>
            <label className="control-label" htmlFor="EffectiveYear" style={{ marginBottom: '0px' }}>
              <b>{t('insurance_information.yyyy')}</b>
            </label>
          </div>
        </div>
        <div className={[styles['date-align'], effectiveDateValid === false && 'has-error'].join(' ')}>
          <input
            ref={effectiveDateDayEl}
            type="text"
            id="EffectiveDate"
            aria-labelledby="EffectiveDate"
            className={['form-control', styles['day_field']].join(' ')}
            value={effectiveDate.split('-')[2] || ''}
            onChange={handleEffectiveDateDay}
            // onBlur={onBlurEffectiveDate}
            onFocus={() => SetIsFocussed(true)}
            autoComplete="off"
            maxLength="3"
          />
          <div className="select fw-20">
            <select
              ref={effectiveDateMonthEl}
              id="EffectiveMonth"
              aria-labelledby="EffectiveMonth"
              value={effectiveDate.split('-')[1] || ''}
              onChange={handleEffectiveDateMonth}
              // onBlur={onBlurEffectiveDate}
              onFocus={() => SetIsFocussed(true)}
              className={['form-control', styles['month_field']].join(' ')}
            >
              <option value="">Select Month</option>
              {months.map((month) => (
                <option key={month.value} value={formatMonth(month.value)}>
                  {month.name}
                </option>
              ))}
            </select>
          </div>
          <input
            ref={effectiveDateYearEl}
            type="text"
            id="EffectiveYear"
            aria-labelledby="EffectiveYear"
            className={['form-control', styles['year_field']].join(' ')}
            value={effectiveDate.split('-')[0] || ''}
            onChange={handleEffectiveDateYear}
            autoComplete="off"
            //onBlur={onBlurEffectiveDate}
            onFocus={() => SetIsFocussed(true)}
            maxLength="4"
          />
        </div>
        {/* <input
          ref={effectiveDateMonthEl}
          type="text"
          id="EffectiveMonth"
          aria-labelledby="EffectiveMonth"
          className={['form-control', styles['month_field']].join(' ')}
          value={effectiveDate.split('-')[1] || ''}
          onChange={handleEffectiveDateMonth}
          autoComplete="off"
          onBlur={onBlurEffectiveDate}
          onFocus={() => SetIsFocussed(true)}
          maxLength="3"
        /> */}

        {effectiveDateValid === true && (effectiveDate === '--' || effectiveDate === '') && (
          <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(EffectiveDate)
